<template>
  <div class="contact">
    <div class="container">
      <div class="contact__wrapper">
        <div class="contact__left">
          <h2 class="contact__title">{{ t('home.contact.title') }}</h2>
          <div class="contact__info">
            <div>
              <a :href="'mailto:' + company?.emailFrom">{{ company?.emailFrom }}</a>
              <p>{{ t('company.phone') }}</p>
            </div>
            <p>
              {{ t('home.contact.address') }}
              <span>{{ t('company.address') }}</span>
            </p>
          </div>
          <button @click="contact">
            {{ t('buttons.sendRequest') }}
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
              <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="#008ECC" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="contact__form">
          <div class="contact__form-box">
            <input
                type="text"
                :placeholder="t('fields.firstName')"
                v-model="firstName"
            >
            <input
                type="text"
                :placeholder="t('fields.lastName')"
                v-model="lastName"
            >
          </div>
          <input
              type="email"
              :placeholder="t('fields.email')"
              v-model="email"
          >
          <input
              type="text"
              :placeholder="t('fields.subject')"
              v-model="subject"
          >
          <textarea
              :placeholder="t('fields.message')"
              v-model="message"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useCompanyStore} from "@/stores/company.js";
import {Processes} from "@/core/api/processes.js";
import {ElNotification} from "element-plus";

const {t} = useI18n()
const companyStore = useCompanyStore()

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const subject = ref('')
const message = ref('')

const contact = async () => {
  const res = await Processes.contact({
    name: firstName.value + lastName.value,
    email: email.value,
    subject: subject.value,
    message: message.value
  })

  if (res.errors) {
    ElNotification({
      title: t('popup.error'),
      message: res.errors[0].message,
      type: 'error'
    })
  } else {
    ElNotification({
      message: t('popup.contactUs'),
      type: 'success'
    })
  }
}
</script>

<style lang="scss" scoped>
.contact {
  margin-top: 100px;
  background-image: url(@images/contactBg.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #008ECC;

  &__wrapper {
    padding-block: 110px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 50px;
  }

  &__left {
    display: flex;
    flex-direction: column;
    gap: 70px;

    color: #F3F9FB;
    text-align: justify;
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;

    & button {
      width: fit-content;
      cursor: pointer;
      border-radius: 27px;
      background-color: #F3F9FB;
      padding: 10px 20px;
      display: flex;
      align-items: center;
      gap: 5px;
      transition: 0.2s;

      color: #222;
      font-size: 21px;
      font-weight: 500;
      line-height: 27px;

      @include hover {
        background-color: #cecece;
      }
    }
  }

  &__title {
    color: $white;
    font-size: 63px;
    font-weight: 700;
    line-height: 63px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 25px;

    & div {
      display: flex;
      align-items: center;
      gap: 20px;

      & a {
        transition: 0.2s;

        @include hover {
          color: #cbcbcb;
        }
      }
    }

    & span {
      color: #F3F9FB;
      font-family: "Hanken Grotesk", sans-serif;
      font-size: 24px;
      font-weight: 200;
      line-height: 30px;
      letter-spacing: 2.64px;
    }
  }

  &__form {
    border-radius: 16px;
    background-color: rgba(203, 239, 255, 0.84);
    box-shadow: 14px 14px 13.9px 0 rgba(0, 0, 0, 0.10);
    padding: 35px 30px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    &-box {
      display: flex;
      align-items: flex-start;
      gap: 15px;
    }

    & input {
      border-radius: 7px;
      background-color: $white;
      padding: 12px 15px;

      color: #6C6C6C;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }

    & textarea {
      resize: none;
      height: 175px;
      border-radius: 7px;
      background-color: $white;
      padding: 12px 15px;

      color: #6C6C6C;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
    }
  }
}

@media (max-width: 1300px) {
  .contact {
    &__wrapper {
      flex-direction: column;
    }
  }
}

@media (max-width: 600px) {
  .contact {
    &__wrapper {
      padding-block: 50px;
    }

    &__title {
      font-size: 42px;
    }

    &__left {
      gap: 25px;
      font-size: 18px;
    }

    &__info {
      & span {
        font-size: 16px;
      }
    }

    &__form {
      width: 100%;

      &-box {
        flex-direction: column;
      }

      & input {
        width: 100%;
      }
    }
  }
}
</style>